<template>
  <vbt-content-box
    :loading="loading"
    :loading-error="loadingError"
    :no-content="noContent"
    title="Package Items"
  >
    <vbt-table
      :headers="headers"
      :items="packageReturnItems"
      show-paginator
    >
      <template #orderId="{ item: { orderId } }">
        <router-link
          :to="{
            name: 'order',
            params: { id: orderId },
            query: { suffix },
          }"
          class="info--text"
          target="_blank"
        >
          {{ orderId }}
        </router-link>
      </template>
    </vbt-table>
  </vbt-content-box>
</template>

<script>
import { mapState } from 'vuex';

import { useIncludedLoading } from '@mixins/factories';

import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { namespace as PackageReturnsNamespace } from '../store.types';

const headers = Object.freeze([
  { text: 'Order ID', value: 'orderId' },
  { text: 'Outer ID', value: 'outerId' },
  { text: 'Customer ID', value: 'customerId' },
  { text: 'Product Type', value: 'productType' },
]);

export default {
  name: 'KernelPackageReturnItems',

  mixins: [
    useIncludedLoading(),
  ],

  data() {
    return {
      headers,
    };
  },

  computed: {
    ...mapState(LocationsNamespace, ['suffix']),

    ...mapState(PackageReturnsNamespace, {
      packageReturnItems: ({ packageReturn: { items } }) => items || [],
    }),

    noContent() {
      return {
        show: !this.packageReturnItems.length,
        msg: 'No content',
      };
    },
  },
};
</script>
